import React, { FC, memo } from 'react'
import ReactMarkdown from 'react-markdown'

import { TipTransport } from '../../../transports/region-landing-page-transport'
import { TipCard, TipCardImage, TipCardContent, TipCardTitle, TipCardDescription, TipCardButton } from './styles'
import ImageLoadingComponent from '../../app-components/image-loading-component'
import { useTranslation } from '../../../hooks/locale'

interface TipsSectionCardProps {
    tip: TipTransport
    location: string
}

const TipsSectionCard: FC<TipsSectionCardProps> = ({ tip }) => {
    const { t } = useTranslation()
    if (!tip.image?.url) {
        return null
    }

    return (
        <TipCard href={tip.cta?.url} target="_blank">
            <TipCardImage>
                <ImageLoadingComponent
                    src={`${tip.image.url}?imwidth=480`}
                    alt={tip.title}
                    objectFit="cover"
                    borderRadius="12px 12px 0 0"
                />
            </TipCardImage>
            <TipCardContent>
                <TipCardTitle>{tip.title}</TipCardTitle>
                <TipCardDescription>
                    <ReactMarkdown>{tip.text}</ReactMarkdown>
                </TipCardDescription>
                <TipCardButton>{t('tipsSectionButtonText')}</TipCardButton>
            </TipCardContent>
        </TipCard>
    )
}

export default memo(TipsSectionCard)
